import ticketListComponent from './ticket-list.component';

const ticketListModule = angular.module('ticketList', [
])
  .component('ticketList', ticketListComponent)
  .name;

export default ticketListModule;
